import React from 'react';
import CheckCircleIcon from 'views/components/icons/CheckCircle';
import WarningIcon from 'views/components/icons/Warning';

const CompletionCard = ({ endSelection = false }) => (
  // const CompletionCard = ({ hasSaveError = false, endSelection = false }) => (
  <section className="completion-card information">
    {/* {hasSaveError ||  */}
    {endSelection ? (
      <>
        <WarningIcon width={40} height={40} viewBox="0 0 23 20" />
        <h1>Assessment Not Available</h1>
        <p>
          This navigator is designed specifically for enterprise organizations. Based on your responses, this assessment may not provide the most relevant
          insights for your organization type.
        </p>
        <p>For questions about Equinix services tailored to your specific needs, please visit our website or contact our sales team.</p>
      </>
    ) : (
      <>
        <CheckCircleIcon width={40} height={40} viewBox="0 0 23 20" />
        <h1>Assessment Submitted</h1>
        <p>
          We&apos;re building your personalized Fabric Design Guide now. You&apos;ll receive an email with a link to access your tailored recommendations within
          a few minutes.
        </p>
      </>
    )}
  </section>
);

export default CompletionCard;
